export default function AmenitiesSkeleton() {
  return (
    <div className="w-full">
      <div className="amenities-grid amenities-grid-responsive aminities-grid aminities-grid-responsive">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="amenity-item aminity-item flex items-start gap-2">
            <div className="amenity-icon aminity-icon">
              <div className="w-4 h-4 bg-muted rounded animate-pulse" />
            </div>
            <div className="amenity-name aminity-name">
              <div className="h-4 bg-muted rounded animate-pulse w-3/4" />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
